import React from 'react';

const Button = ({
  type = 'button',
  variant = 'primary',
  disabled = false,
  className = '',
  children,
  onClick
}) => {
  const baseClasses = 'py-3 px-4 rounded-md focus:outline-none transition-colors duration-200';

  const variantClasses = {
    primary: 'bg-primary text-white hover:bg-red-600 focus:ring-2 focus:ring-offset-2 focus:ring-red-500',
    secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400',
    text: 'bg-transparent text-primary hover:text-red-600'
  };

  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : '';

  const buttonClasses = `${baseClasses} ${variantClasses[variant]} ${disabledClasses} ${className}`;

  return (
    <button
      type={type}
      disabled={disabled}
      className={buttonClasses}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
